/**
 * Human-readable duration for session lock UI.
 * @param {number|string|null|undefined} lockedAtMs
 * @param {number} [nowMs=Date.now()]
 */
export function formatLockedDuration(lockedAtMs, nowMs = Date.now()) {
  const lockedAt = Number(lockedAtMs);
  if (!Number.isFinite(lockedAt) || lockedAt <= 0) {
    return "";
  }

  const totalMinutes = Math.max(0, Math.floor((nowMs - lockedAt) / 60000));

  if (totalMinutes < 1) {
    return "Locked due to inactivity";
  }

  const days = Math.floor(totalMinutes / (60 * 24));
  const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
  const minutes = totalMinutes % 60;

  const parts = [];

  if (days > 0) {
    parts.push(`${days} day${days === 1 ? "" : "s"}`);
  }
  if (hours > 0) {
    parts.push(`${hours} hour${hours === 1 ? "" : "s"}`);
  }
  if (minutes > 0) {
    parts.push(`${minutes} minute${minutes === 1 ? "" : "s"}`);
  }

  if (!parts.length) {
    return "Locked due to inactivity";
  }

  return `Locked for ${parts.join(" ")}`;
}
